import { ExportRow } from '@portal/shared/types/export.types';
import { FieldOperationsSensorsListItem } from './field-operations-sensors.types';

// One row per ExactaGuard + RMD pair; an ExactaGuard without RMDs still exports one row with empty RMD cells.
export const mapFieldOperationsSensorsToExport = (
  item: FieldOperationsSensorsListItem,
  formatDate: (date: string) => string
): ExportRow[] => {
  const common = {
    operationDateTime: {
      title: 'OperationDateTime',
      value: item.lastFieldOperationDate ? formatDate(item.lastFieldOperationDate) : ''
    },
    commDeviceId: { title: 'CommDeviceID', value: item.commDeviceId ?? '' },
    installationReason: { title: 'Reason', value: item.installationReason ?? '' }
  };
  const installedBy = { title: 'InstalledBy', value: item.lastChangedBy ?? '' };

  if (!item.childDevices?.length) {
    return [
      {
        ...common,
        sensorSerialNumber: { title: 'SensorSerialNumber', value: '' },
        port: { title: 'Port', value: '' },
        gnnId: { title: 'GNNID', value: '' },
        lastChangedBy: installedBy
      }
    ];
  }

  return item.childDevices.map(child => ({
    ...common,
    sensorSerialNumber: { title: 'SensorSerialNumber', value: child.serialNumber ?? '' },
    port: { title: 'Port', value: child.port ?? '' },
    gnnId: { title: 'GNNID', value: child.serviceLocationIds ?? '' },
    lastChangedBy: installedBy
  }));
};
